export default {"src":"/_next/static/media/appstore.204e941b.svg","height":79,"width":231,"blurWidth":0,"blurHeight":0};